import React from 'react';
import { ManualText, ROLE_CLASS } from './manualShared';

// Swimlane-style flow: one column per role, one row per step, the reader's own lane highlighted.
const LANES_BY_ROLE = {
    pegawai_hq: ['hq', 'pengesah'],
    pegawai: ['hq', 'pengesah'],
    pegawai_daerah: ['daerah'],
    admin: [],
    system: [],
    awam: ['pengadu'],
    user: ['pengadu'],
};

const ManualFlowChart = ({ flow, roleLabels, viewerRole, onOpenTask }) => {
    const lanes = [...new Set(flow.nodes.map((node) => node.role))];
    const mine = LANES_BY_ROLE[viewerRole] || [];

    return (
        <section className="app-card app-manual-flow">
            <header className="app-manual-flow-head">
                <span className="app-manual-code">{flow.code}</span>
                <div>
                    <h4>{flow.title}</h4>
                    {flow.lede && <p>{flow.lede}</p>}
                </div>
            </header>
            <div className="app-manual-flow-scroll">
                <div className="app-manual-flow-grid" style={{ gridTemplateColumns: `repeat(${lanes.length}, minmax(150px, 1fr)) minmax(110px, 0.6fr)` }}>
                    {lanes.map((lane) => (
                        <div key={`head-${lane}`} className={`app-manual-lane-head ${ROLE_CLASS[lane] || ''}${mine.includes(lane) ? ' is-mine' : ''}`}>
                            {roleLabels[lane] || lane}
                            {mine.includes(lane) && <small>Peranan anda</small>}
                        </div>
                    ))}
                    <div className="app-manual-lane-head is-status">Status aduan</div>
                    {flow.nodes.map((node, index) => (
                        <React.Fragment key={`row-${index}`}>
                            {lanes.map((lane) => {
                                const isHere = lane === node.role;
                                return (
                                    <div key={`cell-${index}-${lane}`} className={`app-manual-lane-cell${mine.includes(lane) ? ' is-mine' : ''}`}>
                                        {isHere && (
                                            <div className={`app-manual-node ${ROLE_CLASS[lane] || ''}`}>
                                                <span className="app-manual-node-num">{index + 1}</span>
                                                <strong>{node.title}</strong>
                                                <p><ManualText text={node.desc} /></p>
                                                {node.note && <p className="app-manual-node-note"><ManualText text={node.note} /></p>}
                                                {node.task && (
                                                    <button type="button" className="app-manual-link" onClick={() => onOpenTask(node.task)}>
                                                        Lihat panduan <i className="bi bi-arrow-right"></i>
                                                    </button>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                            <div className="app-manual-lane-cell is-status">
                                <span className="app-manual-status">{node.status}</span>
                            </div>
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ManualFlowChart;
